
import React, { useState, useMemo, useEffect } from 'react';
import { supabase } from '../supabase';
import { QuestionCard } from './QuestionCard';
import { BookOpenIcon, ChevronRightIcon, ArrowLeftIcon } from './icons/InterfaceIcons';

const mathematicsChapters = [
  {    "name": "Application of Derivatives",    "count": 191  },
  {    "name": "Area Under Curves",    "count": 166  },
  {    "name": "Basic of Mathematics",    "count": 17  },
  {    "name": "Binomial Theorem",    "count": 201  },
  {    "name": "Circle",    "count": 148  },
  {    "name": "Complex Number",    "count": 201  },
  {    "name": "Continuity and Differentiability",    "count": 141  },
  {    "name": "Definite Integration",    "count": 263  },
  {    "name": "Determinants",    "count": 186  },
  {    "name": "Differential Equations",    "count": 221  },
  {    "name": "Differentiation",    "count": 70  },
  {    "name": "Ellipse",    "count": 78  },
  {    "name": "Functions",    "count": 205  },
  {    "name": "Hyperbola",    "count": 55  },
  {    "name": "Indefinite Integration",    "count": 99  },
  {    "name": "Inverse Trigonometric Functions",    "count": 79  },
  {    "name": "Limits",    "count": 75  },
  {    "name": "Matrices",    "count": 199  },
  {    "name": "Parabola",    "count": 70  },
  {    "name": "Permutation Combination",    "count": 193  },
  {    "name": "Probability",    "count": 198  },
  {    "name": "Quadratic Equation",    "count": 180  },
  {    "name": "Sequences and Series",    "count": 275  },
  {    "name": "Sets and Relations",    "count": 107  },
  {    "name": "Statistics",    "count": 148  },
  {    "name": "Straight Lines",    "count": 183  },
  {    "name": "Three Dimensional Geometry",    "count": 171  },
  {    "name": "Trigonometric Equations",    "count": 52  },
  {    "name": "Trigonometric Ratios & Identities",    "count": 54  },
  {    "name": "Vector Algebra",    "count": 248  }
];

const physicsChapters = [
  {    "name": "Alternating Current",    "count": 177  },
  {    "name": "Atomic Physics",    "count": 144  },
  {    "name": "Capacitance",    "count": 163  },
  {    "name": "Center of Mass Momentum and Collision",    "count": 123  },
  {    "name": "Current Electricity",    "count": 345  },
  {    "name": "Dual Nature of Matter",    "count": 180  },
  {    "name": "Electromagnetic Induction",    "count": 132  },
  {    "name": "Electromagnetic Waves",    "count": 145  },
  {    "name": "Electrostatics",    "count": 279  },
  {    "name": "Experimental Physics",    "count": 63  },
  {    "name": "Gravitation",    "count": 210  },
  {    "name": "Kinetic Theory of Gases",    "count": 155  },
  {    "name": "Laws of Motion",    "count": 191  },
  {    "name": "Magnetic Effects of Current",    "count": 255  },
  {    "name": "Magnetic Properties of Matter",    "count": 54  },
  {    "name": "Mathematics in Physics",    "count": 118  },
  {    "name": "Mechanical Properties of Fluids",    "count": 167  },
  {    "name": "Mechanical Properties of Solids",    "count": 101  },
  {    "name": "Motion In One Dimension",    "count": 168  },
  {    "name": "Motion In Two Dimensions",    "count": 118  },
  {    "name": "Nuclear Physics",    "count": 72  },
  {    "name": "Oscillations",    "count": 176  },
  {    "name": "Ray Optics",    "count": 256  },
  {    "name": "Rotational Motion",    "count": 250  },
  {    "name": "Semiconductors",    "count": 186  },
  {    "name": "Thermal Properties of Matter",    "count": 116  },
  {    "name": "Thermodynamics",    "count": 166  },
  {    "name": "Units and Dimensions",    "count": 133  },
  {    "name": "Waves and Sound",    "count": 129  },
  {    "name": "Work Power Energy",    "count": 168  }
];

const chemistryChapters = [
  {    "name": "Alcohols Phenols and Ethers",    "count": 182  },
  {    "name": "Aldehydes and Ketones",    "count": 155  },
  {    "name": "Amines",    "count": 190  },
  {    "name": "Biomolecules",    "count": 194  },
  {    "name": "Carboxylic Acid Derivatives",    "count": 72  },
  {    "name": "Chemical Bonding and Molecular Structure",    "count": 289  },
  {    "name": "Chemical Equilibrium",    "count": 110  },
  {    "name": "Chemical Kinetics",    "count": 206  },
  {    "name": "Chemistry in Everyday Life",    "count": 1  },
  {    "name": "Classification of Elements and Periodicity in Properties",    "count": 168  },
  {    "name": "Coordination Compounds",    "count": 340  },
  {    "name": "d and f Block Elements",    "count": 235  },
  {    "name": "Electrochemistry",    "count": 215  },
  {    "name": "General Organic Chemistry",    "count": 410  },
  {    "name": "Haloalkanes and Haloarenes",    "count": 175  },
  {    "name": "Hydrocarbons",    "count": 214  },
  {    "name": "Ionic Equilibrium",    "count": 141  },
  {    "name": "p Block Elements (Group 13 & 14)",    "count": 86  },
  {    "name": "p Block Elements (Group 15, 16, 17 & 18)",    "count": 184  },
  {    "name": "Practical Chemistry",    "count": 35  },
  {    "name": "Redox Reactions",    "count": 99  },
  {    "name": "Solutions",    "count": 206  },
  {    "name": "Some Basic Concepts of Chemistry",    "count": 188  },
  {    "name": "States of Matter",    "count": 2  },
  {    "name": "Structure of Atom",    "count": 222  },
  {    "name": "Thermodynamics (C)",    "count": 242  }
];

const PAGE_SIZE = 10;

const getDifficultyFromLevel = (level) => {
    switch (level) {
        case 1: return 'Easy';
        case 2: return 'Medium';
        case 3: return 'Hard';
        default: return 'Medium';
    }
};

const ChapterCard: React.FC<{ chapter: { name: string; count: number; }, onClick: () => void }> = ({ chapter, onClick }) => (
    <div onClick={onClick} className="bg-brand-surface border border-brand-border rounded-lg p-4 flex items-center justify-between hover:bg-brand-primary/5 hover:border-brand-primary transition-all duration-200 cursor-pointer group">
        <div className="flex items-center space-x-4">
            <BookOpenIcon className="w-5 h-5 text-brand-text-secondary group-hover:text-brand-primary transition-colors" />
            <div>
                <h3 className="font-semibold text-brand-text-primary">{chapter.name}</h3>
                <p className="text-sm text-brand-text-secondary">{chapter.count} Questions</p>
            </div>
        </div>
        <ChevronRightIcon className="w-5 h-5 text-brand-text-secondary group-hover:text-brand-primary transition-colors" />
    </div>
);

export const JEEMainChapterWiseView = ({ user, onToggleBookmark, onNavigateToSignIn }) => {
    const [activeSubject, setActiveSubject] = useState('Mathematics');
    const [selectedChapter, setSelectedChapter] = useState<string | null>(null);
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [activeDifficulty, setActiveDifficulty] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);

     useEffect(() => {
        if (!selectedChapter) {
            setQuestions([]);
            return;
        }

        const fetchQuestions = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const { data, error: dbError } = await supabase
                    .from('jeemain')
                    .select('*')
                    .eq('subject', activeSubject)
                    .eq('tags', selectedChapter);

                if (dbError) throw dbError;

                if (data) {
                    const formattedQuestions = data.map((q) => ({
                        id: q.id.toString(),
                        text: q.question,
                        options: [q.option1, q.option2, q.option3, q.option4].filter(opt => opt),
                        answer: q.correct,
                        solution: q.explanation,
                        subject: q.subject || 'General',
                        topic: q.tags || 'Unknown Topic',
                        difficulty: getDifficultyFromLevel(q.level),
                        type: q.type || 'Single Choice',
                    }));
                    setQuestions(formattedQuestions);
                }
            } catch (err) {
                console.error('Error fetching chapter questions:', err);
                setError('Failed to load questions for this chapter. Please try again later.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuestions();
    }, [selectedChapter, activeSubject]);
    
    const difficultyFilteredQuestions = useMemo(() => {
        if (activeDifficulty === 'All') {
            return questions;
        }
        return questions.filter(q => q.difficulty === activeDifficulty);
    }, [questions, activeDifficulty]);

    const totalPages = Math.ceil(difficultyFilteredQuestions.length / PAGE_SIZE);
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const questionsForCurrentPage = difficultyFilteredQuestions.slice(startIndex, startIndex + PAGE_SIZE);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            document.querySelector('main')?.scrollTo(0, 0);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            document.querySelector('main')?.scrollTo(0, 0);
        }
    };

    const handleChapterSelect = (chapterName: string) => {
        setSelectedChapter(chapterName);
        setActiveDifficulty('All');
        setCurrentPage(1);
        window.scrollTo(0, 0);
    };
    
    const handleDifficultyChange = (difficultyName: string) => {
        setActiveDifficulty(difficultyName);
        setCurrentPage(1);
    };

    const handleBackToChapters = () => {
        setSelectedChapter(null);
        setError(null);
        setQuestions([]);
        setActiveDifficulty('All');
        setCurrentPage(1);
    };

    const chapters = useMemo(() => {
        if (activeSubject === 'Mathematics') return mathematicsChapters;
        if (activeSubject === 'Physics') return physicsChapters;
        return chemistryChapters;
    }, [activeSubject]);

    const SubjectButton = ({ subjectName }) => {
        const isActive = activeSubject === subjectName;
        return (
            <button
                onClick={() => setActiveSubject(subjectName)}
                className={`flex-1 py-3 px-4 text-center text-base font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary ${
                    isActive
                        ? 'border-b-2 border-brand-primary text-brand-primary'
                        : 'border-b-2 border-transparent text-brand-text-secondary hover:text-brand-text-primary hover:border-gray-300'
                }`}
            >
                {subjectName}
            </button>
        );
    };

    if (selectedChapter) {
        // FIX: Add explicit types for props to allow 'key' prop in map.
        const DifficultyButton: React.FC<{ difficultyName: string }> = ({ difficultyName }) => {
            const isActive = activeDifficulty === difficultyName;
            return (
                <button
                    onClick={() => handleDifficultyChange(difficultyName)}
                    className={`py-3 px-4 text-center text-sm font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary ${
                        isActive
                            ? 'border-b-2 border-brand-primary text-brand-primary'
                            : 'border-b-2 border-transparent text-brand-text-secondary hover:text-brand-text-primary hover:border-gray-300'
                    }`}
                >
                    {difficultyName}
                </button>
            );
        };

        return (
            <div className="animate-fade-in space-y-6">
                <header>
                    <button onClick={handleBackToChapters} className="flex items-center space-x-2 text-sm font-semibold text-brand-text-secondary hover:text-brand-primary transition-colors mb-4">
                        <ArrowLeftIcon className="w-5 h-5" />
                        <span>Back to Chapters</span>
                    </button>
                    <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">{selectedChapter}</h1>
                    <p className="mt-2 text-lg text-brand-text-secondary">
                        Practice questions for {activeSubject}.
                    </p>
                </header>

                <div className="sticky top-[63px] z-10 bg-brand-bg/90 backdrop-blur-sm -my-2 py-2">
                    <nav className="flex items-center border-b border-brand-border">
                        {['All', 'Easy', 'Medium', 'Hard'].map(difficulty => (
                            <DifficultyButton key={difficulty} difficultyName={difficulty} />
                        ))}
                    </nav>
                </div>

                {isLoading && (
                    <div className="flex-1 flex items-center justify-center min-h-[calc(100vh-400px)]">
                        <div className="flex flex-col items-center">
                            <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
                            <p className="mt-4 text-brand-text-secondary">Fetching questions...</p>
                        </div>
                    </div>
                )}
                
                {error && (
                    <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border border-red-200">
                        <h3 className="text-lg font-semibold text-brand-accent-red">An Error Occurred</h3>
                        <p className="text-brand-text-secondary mt-1">{error}</p>
                    </div>
                )}
                
                {!isLoading && !error && (
                    difficultyFilteredQuestions.length > 0 ? (
                        <div className="space-y-6">
                            {questionsForCurrentPage.map(q => {
                                const isBookmarked = !!user?.bookmarks?.questions?.[q.id];
                                return <QuestionCard key={q.id} question={q} user={user} isBookmarked={isBookmarked} onToggleBookmark={onToggleBookmark} onNavigateToSignIn={onNavigateToSignIn} />;
                            })}

                            {totalPages > 1 && (
                                <div className="flex items-center justify-between mt-8 pt-4 border-t border-brand-border">
                                    <button
                                        onClick={handlePrevPage}
                                        disabled={currentPage === 1}
                                        className="px-4 py-2 text-sm font-semibold rounded-lg border border-brand-border bg-brand-surface hover:bg-gray-100 dark:hover:bg-zinc-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Previous
                                    </button>
                                    <span className="text-sm font-semibold text-brand-text-secondary">
                                        Page {currentPage} of {totalPages}
                                    </span>
                                    <button
                                        onClick={handleNextPage}
                                        disabled={currentPage === totalPages}
                                        className="px-4 py-2 text-sm font-semibold rounded-lg border border-brand-border bg-brand-surface hover:bg-gray-100 dark:hover:bg-zinc-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                         <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border">
                            <h3 className="text-lg font-semibold text-brand-text-primary">No Questions Found</h3>
                            <p className="text-brand-text-secondary mt-1">
                                {questions.length > 0 
                                    ? `There are no "${activeDifficulty}" questions in this chapter. Try another difficulty.`
                                    : `We couldn't find any questions for this chapter yet. Please check back later.`
                                }
                            </p>
                        </div>
                    )
                )}
            </div>
        );
    }

    return (
        <div className="animate-fade-in space-y-6">
            <header>
                <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">JEE Main: Chapter Wise Practice</h1>
                <p className="mt-2 text-lg text-brand-text-secondary">
                    Select a subject to see available chapters for your practice session.
                </p>
            </header>

            <div className="sticky top-[63px] z-10 bg-brand-bg/90 backdrop-blur-sm -my-2 py-2">
                <nav className="flex items-center border-b border-brand-border">
                    <SubjectButton subjectName="Mathematics" />
                    <SubjectButton subjectName="Physics" />
                    <SubjectButton subjectName="Chemistry" />
                </nav>
            </div>
            
            <div className="mt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {chapters.map(chapter => (
                        <ChapterCard key={chapter.name} chapter={chapter} onClick={() => handleChapterSelect(chapter.name)} />
                    ))}
                </div>
            </div>
        </div>
    );
};
